import { request, buildQuery } from '../../lib/apiClient';
export function listInstallers(params) {
    const query = buildQuery({
        name: params?.name,
        email: params?.email,
        status: params?.status,
        skill: params?.skill,
        limit: params?.limit,
        nextToken: params?.nextToken,
    });
    return request(`/installers${query}`);
}
export function getInstaller(id) {
    return request(`/installers/${id}`);
}
export function createInstaller(input) {
    return request('/installers', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function updateInstaller(id, input) {
    return request(`/installers/${id}`, {
        method: 'PUT',
        body: JSON.stringify(input),
    });
}
export function updateInstallerStatus(id, status) {
    return request(`/installers/${id}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ status }),
    });
}
export function getInstallerProjects(id, params) {
    const query = buildQuery({
        status: params?.status,
        limit: params?.limit,
    });
    return request(`/installers/${id}/projects${query}`);
}
//# sourceMappingURL=api.js.map